import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusTranslatorG'
})
export class GlobalSearchTranslatorPipe implements PipeTransform {
  transform(status: string, valueView?: boolean): any {
    const statusMatches = {
      rate_offered: 'offered',
      rate_offeredView: 'rate offered',
      awaiting_price: 'waiting',
      awaiting_priceView: 'awaiting price',
      expired_decline: 'history',
      expired_declined: 'history',
      expired_declineView: 'expired / declined',
      expired_declinedView: 'expired / declined',
      my_orders: 'my orders',
      in_transit: 'in transit',
      intransit: 'in transit',
      not_signed: 'not signed',
      signed: 'dispatched',
      dispatched: 'dispatched',
      posted: 'posted',
      damage: 'on hold',
      delivered: 'delivered',
      delivered_paid: 'paid bills',
      open_invoice: 'open invoice',
      pending_ach: 'pending ACH',
      pending_checks: 'pending checks',
      ach_for_today: 'ACH for today',
      ach_today: 'ACH for today',
      checks_for_today: 'checks for today',
      checks_today: 'checks for today',
      tracking_orders: 'my orders',
      awaiting: 'waiting',
      pending_request: 'pending request',
      assigned: 'assigned',
      not_assigned: 'not assigned',
      assigned_to_me: 'assigned to me',
      shippers: 'shippers',
      cancelled: 'cancelled',
      active: 'posted',
      pending_bol: 'pending BOL'
    };
    return statusMatches[status]
      ? valueView
        ? statusMatches[status + 'View']
          ? statusMatches[status + 'View']
          : statusMatches[status]
        : statusMatches[status]
      : status;
  }
}
